/**
 * Replaces the default bpmn-js TextRenderer with one that truncates labels to 25 chars.
 */
import TruncatingTextRenderer from './TruncatingTextRenderer';

const truncatingTextRendererModule = {
  textRenderer: ['type', TruncatingTextRenderer]
};
export default truncatingTextRendererModule;
